import { useState, useRef, useCallback } from "react";
import makeid from "../../../Universal/Makeid";
import { validateFile } from "../utils/fileHelpers";
import { uploadFile } from "../../../../api/chat";

const useFileAttachments = () => {
  const [attachedFiles, setAttachedFiles] = useState([]);
  const fileInputRef = useRef(null);

  const handleFilesSelected = useCallback((files) => {
    const fileList = Array.from(files);
    fileList.forEach((file) => {
      const error = validateFile(file);
      if (error) {
        // Add as error entry briefly, then remove after 3s
        const errorId = makeid(12);
        setAttachedFiles((prev) => [
          ...prev,
          {
            id: errorId,
            file,
            name: file.name,
            status: "error",
            error,
            docId: null,
          },
        ]);
        setTimeout(() => {
          setAttachedFiles((prev) => prev.filter((f) => f.id !== errorId));
        }, 3000);
        return;
      }

      const fileId = makeid(12);
      setAttachedFiles((prev) => [
        ...prev,
        {
          id: fileId,
          file,
          name: file.name,
          status: "uploading",
          error: null,
          docId: null,
        },
      ]);

      uploadFile(file)
        .then((res) => {
          console.log("uploadFile raw response:", res?.data);
          let data = res?.data;
          if (typeof data === "string") {
            try {
              data = JSON.parse(data);
            } catch {
              data = {};
            }
          }
          console.log("uploadFile parsed data:", data);
          const docId = data?.value;
          if (docId) {
            setAttachedFiles((prev) =>
              prev.map((f) =>
                f.id === fileId ? { ...f, status: "done", docId } : f,
              ),
            );
          } else {
            setAttachedFiles((prev) =>
              prev.map((f) =>
                f.id === fileId
                  ? { ...f, status: "error", error: "Upload failed" }
                  : f,
              ),
            );
          }
        })
        .catch(() => {
          setAttachedFiles((prev) =>
            prev.map((f) =>
              f.id === fileId
                ? { ...f, status: "error", error: "Upload failed" }
                : f,
            ),
          );
        });
    });
  }, []);

  const removeAttachedFile = useCallback((fileId) => {
    setAttachedFiles((prev) => prev.filter((f) => f.id !== fileId));
  }, []);

  const getReadyDocIds = useCallback(() => {
    return attachedFiles
      .filter((f) => f.status === "done" && f.docId)
      .map((f) => f.docId);
  }, [attachedFiles]);

  const clearAttachedFiles = useCallback(() => {
    setAttachedFiles([]);
  }, []);

  return {
    attachedFiles,
    fileInputRef,
    handleFilesSelected,
    removeAttachedFile,
    getReadyDocIds,
    clearAttachedFiles,
  };
};

export default useFileAttachments;
